export * from './admin-toolbar-responsible.component';
